var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-metric"},[_c('Typography',{attrs:{"variant":"body-1"}},[_vm._v(_vm._s(_vm.title))]),_c('Typography',{class:{ 'error--text': _vm.error, 'success--text': _vm.success },attrs:{"variant":"h-2"}},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }